import { selectAnatomy } from '@chakra-ui/react/anatomy';
import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

import { selectSlotRecipe } from './Select.recipe';

const datePickerSelectSlotRecipe = defineSlotRecipe({
  className: 'datePickerSelect',
  slots: selectAnatomy.keys(),
  base: {
    trigger: {
      ...selectSlotRecipe.base?.trigger,
      borderWidth: 0,
      height: '32',
      paddingInlineStart: '12',
      paddingInlineEnd: '8',
      '&:hover:not(:active)': {
        bg: 'background/hover',
      },
      '&:active': {
        bg: 'background/active',
      },
    },
    indicator: {
      ...selectSlotRecipe.base?.indicator,
      color: 'icon/tertiary',
      _icon: {
        width: '16',
        height: '16',
      },
    },
    indicatorGroup: {
      ...selectSlotRecipe.base?.indicatorGroup,
      paddingInline: '8',
    },
  },
  variants: {
    size: {
      md: {
        ...selectSlotRecipe.variants?.size?.md,
        trigger: {
          ...selectSlotRecipe.variants?.size?.md.trigger,
          paddingBlock: '6',
        },
        indicator: {
          _icon: {
            width: '16',
            height: '16',
          },
        },
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export default datePickerSelectSlotRecipe;
